import React, { useEffect } from 'react';
import { Modal } from 'antd';
import event from '~helpers/mixpanel';
import { ShowVideo, VideoDownload } from 'common/components/svgs';
import { pageType } from '~constants/pages';
import { helpCenterLink } from 'common/constants/link';

const TutorialModal = ({ t, visible, onCancel, from }) => {
  useEffect(() => {
    if (visible) {
      event('Viewed Tutorial Page', {
        'Auth Method': from,
        'Current Page Type': pageType.tutorial,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visible]);
  return (
    <Modal centered title="" visible={visible} footer={null} onCancel={onCancel} width={812}>
      <div className="counteroffer-help__modal">
        <h2 className="counteroffer-help__modal-tile">{t('counter.offer.help_modal.summary')}</h2>

        <div className="counteroffer-help__modal-summary-title">
          <span className="counteroffer-help__modal-leftBorder" />
          <span>{t('counter.offer.help_modal.summary_title')}</span>
        </div>
        <div className="counteroffer-help__modal-video-line  counteroffer-help__first">
          <ShowVideo className="counteroffer-help__modal-icon" />
          <span className="counteroffer-help__modal-video-title">
            {t('counter.offer.help_modal.accept_video_title')}
          </span>

          <a
            className="counteroffer-help__modal-icon-float"
            href={helpCenterLink.counterOffer.actions}
            download
          >
            <VideoDownload className="counteroffer-help__modal-icon  " />
          </a>
        </div>
        <div className="counteroffer-help__modal-video-line">
          <ShowVideo className="counteroffer-help__modal-icon" />
          <span className="counteroffer-help__modal-video-title">
            {t('counter.offer.help_modal.deep_video_title')}
          </span>

          <a
            className="counteroffer-help__modal-icon-float"
            href={helpCenterLink.counterOffer.deepDive}
            download
          >
            <VideoDownload className="counteroffer-help__modal-icon  " />
          </a>
        </div>
        <div className="counteroffer-help__modal-video-line">
          <ShowVideo className="counteroffer-help__modal-icon" />
          <span className="counteroffer-help__modal-video-title">
            {t('counter.offer.help_modal.editing_video_title')}
          </span>
          <a
            className="counteroffer-help__modal-icon-float"
            href={helpCenterLink.counterOffer.editing}
            download
          >
            <VideoDownload className="counteroffer-help__modal-icon  " />
          </a>
        </div>
      </div>
    </Modal>
  );
};

export default TutorialModal;
